var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppSidebar",
    {
      attrs: {
        title: _vm.title,
        "title-editable": !_vm.isReadOnly && !_vm.isLoading,
        "title-placeholder": _vm.$t("calendar", "Event title"),
        subtitle: _vm.subTitle,
        empty: _vm.isLoading || _vm.isError
      },
      on: { close: _vm.cancel, "update:title": _vm.updateTitle },
      scopedSlots: _vm._u(
        [
          !_vm.isLoading && !_vm.isError
            ? {
                key: "primary-actions",
                fn: function() {
                  return [
                    _vm.showCalendarPicker
                      ? _c("PropertyCalendarPicker", {
                          attrs: {
                            calendars: _vm.calendars,
                            calendar: _vm.selectedCalendar,
                            "is-read-only": _vm.isReadOnly
                          },
                          on: { selectCalendar: _vm.changeCalendar }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("PropertyTitleTimePicker", {
                      attrs: {
                        "start-date": _vm.startDate,
                        "start-timezone": _vm.startTimezone,
                        "end-date": _vm.endDate,
                        "end-timezone": _vm.endTimezone,
                        "is-all-day": _vm.isAllDay,
                        "is-read-only": _vm.isReadOnly,
                        "can-modify-all-day": _vm.canModifyAllDay,
                        "user-timezone": _vm.currentUserTimezone
                      },
                      on: {
                        updateStartDate: _vm.updateStartDate,
                        updateStartTimezone: _vm.updateStartTimezone,
                        updateEndDate: _vm.updateEndDate,
                        updateEndTimezone: _vm.updateEndTimezone,
                        toggleAllDay: _vm.toggleAllDay
                      }
                    })
                  ]
                },
                proxy: true
              }
            : null,
          {
            key: "header",
            fn: function() {
              return [
                _c("IllustrationHeader", {
                  attrs: {
                    color: _vm.illustrationColor,
                    "illustration-url": _vm.backgroundImage
                  }
                })
              ]
            },
            proxy: true
          },
          !_vm.isLoading && !_vm.isError
            ? {
                key: "secondary-actions",
                fn: function() {
                  return [
                    _vm.hasDownloadURL
                      ? _c(
                          "ActionLink",
                          {
                            attrs: {
                              icon: "icon-download",
                              href: _vm.downloadURL
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t" +
                                _vm._s(_vm.$t("calendar", "Download")) +
                                "\n\t\t"
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canDelete && !_vm.canCreateRecurrenceException
                      ? _c(
                          "ActionButton",
                          {
                            attrs: { icon: "icon-delete" },
                            on: {
                              click: function($event) {
                                return _vm.deleteAndLeave(false)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t" +
                                _vm._s(_vm.$t("calendar", "Delete")) +
                                "\n\t\t"
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canDelete && _vm.canCreateRecurrenceException
                      ? _c(
                          "ActionButton",
                          {
                            attrs: { icon: "icon-delete" },
                            on: {
                              click: function($event) {
                                return _vm.deleteAndLeave(false)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t" +
                                _vm._s(
                                  _vm.$t("calendar", "Delete this occurrence")
                                ) +
                                "\n\t\t"
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canDelete && _vm.canCreateRecurrenceException
                      ? _c(
                          "ActionButton",
                          {
                            attrs: { icon: "icon-delete" },
                            on: {
                              click: function($event) {
                                return _vm.deleteAndLeave(true)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "calendar",
                                    "Delete this and all future"
                                  )
                                ) +
                                "\n\t\t"
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                },
                proxy: true
              }
            : null
        ],
        null,
        true
      )
    },
    [
      _vm.isLoading
        ? [
            _c("div", { staticClass: "app-sidebar__loading-indicator" }, [
              _c("div", {
                staticClass:
                  "icon icon-loading app-sidebar-tab-loading-indicator__icon"
              })
            ])
          ]
        : _vm.isError
        ? [
            _c(
              "EmptyContent",
              {
                attrs: { icon: "icon-calendar-dark" },
                scopedSlots: _vm._u([
                  {
                    key: "desc",
                    fn: function() {
                      return [
                        _vm._v("\n\t\t\t\t" + _vm._s(_vm.error) + "\n\t\t\t")
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.$t("calendar", "Event does not exist")) +
                    "\n\t\t\t"
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      _vm._v(" "),
      !_vm.isLoading && !_vm.isError
        ? _c(
            "AppSidebarTab",
            {
              staticClass: "app-sidebar-tab",
              attrs: {
                id: "app-sidebar-tab-details",
                icon: "icon-details",
                name: _vm.$t("calendar", "Details"),
                order: 0
              }
            },
            [
              _c(
                "div",
                { staticClass: "app-sidebar-tab__content" },
                [
                  _c("PropertyText", {
                    attrs: {
                      "is-read-only": _vm.isReadOnly,
                      "prop-model": _vm.rfcProps.location,
                      value: _vm.location
                    },
                    on: { "update:value": _vm.updateLocation }
                  }),
                  _vm._v(" "),
                  _c("PropertyText", {
                    attrs: {
                      "is-read-only": _vm.isReadOnly,
                      "prop-model": _vm.rfcProps.description,
                      value: _vm.description
                    },
                    on: { "update:value": _vm.updateDescription }
                  }),
                  _vm._v(" "),
                  _c("PropertySelect", {
                    attrs: {
                      "is-read-only": _vm.isReadOnly,
                      "prop-model": _vm.rfcProps.status,
                      value: _vm.status
                    },
                    on: { "update:value": _vm.updateStatus }
                  }),
                  _vm._v(" "),
                  _c("PropertySelect", {
                    attrs: {
                      "is-read-only": _vm.isReadOnly,
                      "prop-model": _vm.rfcProps.accessClass,
                      value: _vm.accessClass
                    },
                    on: { "update:value": _vm.updateAccessClass }
                  }),
                  _vm._v(" "),
                  _c("PropertySelect", {
                    attrs: {
                      "is-read-only": _vm.isReadOnly,
                      "prop-model": _vm.rfcProps.timeTransparency,
                      value: _vm.timeTransparency
                    },
                    on: { "update:value": _vm.updateTimeTransparency }
                  }),
                  _vm._v(" "),
                  _c("PropertySelectMultiple", {
                    attrs: {
                      "colored-options": true,
                      "is-read-only": _vm.isReadOnly,
                      "prop-model": _vm.rfcProps.categories,
                      value: _vm.categories
                    },
                    on: {
                      addSingleValue: _vm.addCategory,
                      removeSingleValue: _vm.removeCategory
                    }
                  }),
                  _vm._v(" "),
                  _c("PropertyColor", {
                    attrs: {
                      "calendar-color": _vm.selectedCalendarColor,
                      "is-read-only": _vm.isReadOnly,
                      "prop-model": _vm.rfcProps.color,
                      value: _vm.color
                    },
                    on: { "update:value": _vm.updateColor }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.showSaveButtons
                ? _c("SaveButtons", {
                    staticClass: "app-sidebar-tab__buttons",
                    attrs: {
                      "can-create-recurrence-exception":
                        _vm.canCreateRecurrenceException,
                      "is-new": _vm.isNew,
                      "force-this-and-all-future": _vm.forceThisAndAllFuture
                    },
                    on: {
                      saveThisOnly: function($event) {
                        return _vm.saveAndLeave(false)
                      },
                      saveThisAndAllFuture: function($event) {
                        return _vm.saveAndLeave(true)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && !_vm.isError
        ? _c(
            "AppSidebarTab",
            {
              staticClass: "app-sidebar-tab",
              attrs: {
                id: "app-sidebar-tab-attendees",
                icon: "icon-group",
                name: _vm.$t("calendar", "Attendees"),
                order: 1
              }
            },
            [
              _c(
                "div",
                { staticClass: "app-sidebar-tab__content" },
                [
                  !_vm.isLoading
                    ? _c("InviteesList", {
                        attrs: {
                          "calendar-object-instance":
                            _vm.calendarObjectInstance,
                          "is-read-only": _vm.isReadOnly
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.showSaveButtons
                ? _c("SaveButtons", {
                    staticClass: "app-sidebar-tab__buttons",
                    attrs: {
                      "can-create-recurrence-exception":
                        _vm.canCreateRecurrenceException,
                      "is-new": _vm.isNew,
                      "force-this-and-all-future": _vm.forceThisAndAllFuture
                    },
                    on: {
                      saveThisOnly: function($event) {
                        return _vm.saveAndLeave(false)
                      },
                      saveThisAndAllFuture: function($event) {
                        return _vm.saveAndLeave(true)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && !_vm.isError
        ? _c(
            "AppSidebarTab",
            {
              staticClass: "app-sidebar-tab",
              attrs: {
                id: "app-sidebar-tab-reminders",
                icon: "icon-reminder",
                name: _vm.$t("calendar", "Reminders"),
                order: 2
              }
            },
            [
              _c(
                "div",
                { staticClass: "app-sidebar-tab__content" },
                [
                  _c("AlarmList", {
                    attrs: {
                      "calendar-object-instance": _vm.calendarObjectInstance,
                      "is-read-only": _vm.isReadOnly
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.showSaveButtons
                ? _c("SaveButtons", {
                    staticClass: "app-sidebar-tab__buttons",
                    attrs: {
                      "can-create-recurrence-exception":
                        _vm.canCreateRecurrenceException,
                      "is-new": _vm.isNew,
                      "force-this-and-all-future": _vm.forceThisAndAllFuture
                    },
                    on: {
                      saveThisOnly: function($event) {
                        return _vm.saveAndLeave(false)
                      },
                      saveThisAndAllFuture: function($event) {
                        return _vm.saveAndLeave(true)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && !_vm.isError
        ? _c(
            "AppSidebarTab",
            {
              staticClass: "app-sidebar-tab",
              attrs: {
                id: "app-sidebar-tab-repeat",
                icon: "icon-repeat",
                name: _vm.$t("calendar", "Repeat"),
                order: 3
              }
            },
            [
              _c(
                "div",
                { staticClass: "app-sidebar-tab__content" },
                [
                  _c("Repeat", {
                    attrs: {
                      "calendar-object-instance": _vm.calendarObjectInstance,
                      "recurrence-rule":
                        _vm.calendarObjectInstance.recurrenceRule,
                      "is-read-only": _vm.isReadOnly,
                      "is-editing-master-item": _vm.isEditingMasterItem,
                      "is-recurrence-exception": _vm.isRecurrenceException
                    },
                    on: { forceThisAndAllFuture: _vm.forceModifyingFuture }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.showSaveButtons
                ? _c("SaveButtons", {
                    staticClass: "app-sidebar-tab__buttons",
                    attrs: {
                      "can-create-recurrence-exception":
                        _vm.canCreateRecurrenceException,
                      "is-new": _vm.isNew,
                      "force-this-and-all-future": _vm.forceThisAndAllFuture
                    },
                    on: {
                      saveThisOnly: function($event) {
                        return _vm.saveAndLeave(false)
                      },
                      saveThisAndAllFuture: function($event) {
                        return _vm.saveAndLeave(true)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }